import { type FocusSession, FocusSessionSchema } from '../model/schema'

export interface FocusSessionDto {
  id: string
  employee_id: string
  started_at: string
  state: string
  created_at: string
  updated_at: string
}

export function toFocusSession(dto: FocusSessionDto): FocusSession {
  return FocusSessionSchema.parse({
    id: dto.id,
    employeeId: dto.employee_id,
    startedAt: dto.started_at,
    state: dto.state,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
  })
}
